import type { Theme } from '@mui/material/styles'

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: 'var(--spacing-m)',
    width: 'min(100%, var(--content-L-max-width, 37.5em))',
    mx: 'auto',
    height: '100%',
    py: { xs: 'var(--spacing-m)', md: 'var(--spacing-l)' },
  },
  content: {
    flexGrow: 2,
  },
  carousel: {
    m: -1,
  },
  carouselCard: {
    m: 1,
  },
  articlesListMobile: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'var(--spacing-s)',
    '& img': {
      maxHeight: '10em',
    },
  },
  articlesListDesktop: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 'var(--spacing-s)',
    '&.withHighlighted': {
      // NOTE: because the grid direction is by rows, the highlighted elems are in position 1 & 6
      // On any changes on grid, review the `isHighlighted` var in ArticlesList comp
      '& > button:nth-of-type(8n+1),button:nth-of-type(8n+6)': {
        gridRow: 'span 3',
        height: '100%',
      },
    },
    '& > button': {
      gridRow: 'span 1',
    },
  },
  highlightedCard: {
    my: { xs: 1, lg: 0 },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 'var(--spacing-s)',
    my: 'var(--spacing-xl)',
    mx: 'auto',
    maxWidth: '22em',
    textAlign: 'center',
  },
  emptyStateIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '4em',
    height: '4em',
    borderRadius: 'var(--corners-l)',
    backgroundColor: 'neutral.light',
    color: 'neutral.dark',
  },
  emptyStateIconError: {
    backgroundColor: 'error.light',
    color: 'error.main',
  },
  emptyStateText: {
    color: 'neutral.dark',
    fontSize: { xs: '1em', sm: '1.25em' },
  },
  showMoreButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mt: (theme: Theme) => ({
      xs: theme.spacing(1),
      lg: theme.spacing(1.5),
    }),
    mb: (theme: Theme) => ({
      xs: theme.spacing(2),
      lg: theme.spacing(3),
    }),
    '&  button': {
      width: (theme: Theme) => ({
        xs: '100%',
        md: `min(100%, ${theme.spacing(19.5)})`,
      }),
      mx: 'auto',
    },
  },
}

export default styles
